import { useEffect, useState } from "react";
import { api } from "./api";

// Title-case an arbitrary slug (fallback when a post references a type that
// no longer exists in the admin list).
export const titleCase = (slug) =>
  String(slug || "")
    .split(/[-_]/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export const labelForType = (typeId, typesList) => {
  if (!typeId) return "Post";
  const match = (typesList || []).find((t) => t.id === typeId);
  if (match) return match.label || titleCase(typeId);
  return titleCase(typeId) || "Post";
};

// Tiny hook — fetches /api/post-types once on mount. Returns the list plus a
// ready label resolver. Kept dependency-free (no context) because it's only
// used by a handful of components and the call is cached by the browser.
export const usePostTypes = () => {
  const [types, setTypes] = useState([]);
  useEffect(() => {
    let alive = true;
    api
      .get("/post-types")
      .then((r) => alive && setTypes(Array.isArray(r.data) ? r.data : []))
      .catch(() => alive && setTypes([]));
    return () => {
      alive = false;
    };
  }, []);
  return {
    types,
    label: (id) => labelForType(id, types),
  };
};
